// Web version
export const Platform = {
  OS: 'web',
  select: <T extends { web: T[keyof T]; default?: T[keyof T] }>(obj: T): T[keyof T] => {
    return obj.web || obj.default as T[keyof T];
  }
};

export const getRedirectUrl = (path: string) => {
  return `${window.location.origin}${path}`;
}; 